import { AdAccountsByUserQuery } from '../../types';

export const mockAdAccountsList = [
  {
    name: 'EcoBean',
    id: 'brand-1',
    accountList: [
      { id: '7e3ec17c-f346-4a12-b7a0-0fb83b45948c', label: 'Ad Account Name 1', isBaymaxEnabled: false },
      { id: 'f346-4a12-b7a0-0fb83b45948c-7e3ec17c', label: 'Ad Account Name 2', isBaymaxEnabled: false },
    ],
  },
];

export const fetchedAdAccountsListData = {
  adAccountsByUser: {
    edges: [
      {
        node: {
          id: '7e3ec17c-f346-4a12-b7a0-0fb83b45948c',
          name: 'Ad Account Name 1',
          brand: { id: 'brand-1', name: 'EcoBean' },
          organizationId: '6a822857-512d-46de-b944-e0667f5e09d6',
        },
      },
      {
        node: {
          id: 'f346-4a12-b7a0-0fb83b45948c-7e3ec17c',
          name: 'Ad Account Name 2',
          brand: { id: 'brand-1', name: 'EcoBean' },
          organizationId: '6a822857-512d-46de-b944-e0667f5e09d6',
        },
      },
    ],
  },
};

export const fetchedAdAccountsListDataWithDifferentOrganizations = {
  adAccountsByUser: {
    edges: [
      {
        node: {
          id: '7e3ec17c-f346-4a12-b7a0-0fb83b45948c',
          name: 'Ad Account Name 1',
          brand: { id: 'brand-1', name: 'EcoBean', industry: { id: '' } },
          organizationId: '6a822857-512d-46de-b944-e0667f5e09d6',
        },
      },
      {
        node: {
          id: 'f346-4a12-b7a0-0fb83b45948c-7e3ec17c',
          name: 'Ad Account Name 2',
          brand: { id: 'brand-1', name: 'EcoBean' },
          organizationId: '6a822857-512d-46de-b944-e0667f5e09d6',
        },
      },
      {
        node: {
          id: 'f346-4a12-b7a0-0fb83b45948c-7e3ec17b',
          name: 'Ad Account Name 3',
          brand: { id: 'brand-2', name: 'EcoBean2' },
          organizationId: '6a822857-e0667f5e09d6-512d-46de-b944',
        },
      },
    ],
  },
};

export const mockForDemoAdAccountsList = [
  {
    name: 'Brand Name 1',
    id: 'brand-id-1',
    accountList: [
      { id: 'ad-account-id-1', label: 'Ad Account 1', isBaymaxEnabled: false },
      { id: 'ad-account-id-2', label: 'Ad Account 2', isBaymaxEnabled: false },
    ],
  },
];

export const MockedAdAccountsByUser: AdAccountsByUserQuery = {
  adAccountsByUser: {
    edges: [
      {
        cursor: '',
        node: {
          id: 'ad-account-id-1',
          name: 'Ad Account 1',
          brand: {
            id: 'brand-id-1',
            name: 'Brand Name 1',
            industry: {
              id: '0eb098ef-c100-48a9-8dc1-98a2c9a638fa',
              name: 'Industry Name 1',
              __typename: 'Industry',
            },
            __typename: 'Brand',
          },
          organizationId: 'organization-id-1',
          isBaymaxEnabled: false,
          __typename: 'AdAccount',
        },
        __typename: 'AdAccountEdge',
      },
    ],
    total: 1,
    __typename: 'AdAccountsPages',
  },
};
